export default {"src":"/_next/static/media/oven-gen.e07a7150.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};